import React, { useEffect, useState } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import moment from 'moment';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const { id } = props;
  const [dataChanging, setDataChanging] = useState([]);
  const [products, setProducts] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listProducts() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: 7, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listProducts();
    }
  }, [cuota.open]);

  useEffect(() => {
    if (products.length > 0 && cuota.logi_product_id) {
      handleChange("logi_product_id", String(cuota.logi_product_id));
    }
  },[products]);

  return (
    <>
      <Modal
        title={`Nueva Cuota Detalle de Grupo`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-grupo-detalle-periodo'
        dataForce={
          {
            cuota_grupo_periodo_id: id,
            logi_product_id: dataChanging.logi_product_id
          }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={products}
          getOptionLabel={(item) => `(${item.ItemCode}) ${item.ItemName}`}
          renderInput={(params) => (
            <TextField {...params} label="Producto" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('logi_product_id', item?.id);}}
          value={products.find((prod) => String(prod.id) === String(dataChanging.logi_product_id)) || null }
        />
      </Modal>
    </>
  );
});

